import React from "react";
import { components } from "react-select";
import ReactSelectCreatable from "react-select/creatable";
import ReactSelectAsyncCreatable from "react-select/async-creatable";
import ReactSelectAsync from "react-select/async";
import ArrowDropDown from "@material-ui/icons/ArrowDropDown";
import Close from "@material-ui/icons/Close";
import MenuItem from "@material-ui/core/MenuItem";

const customComponents = {
  ClearIndicator: ({ innerProps: { ref, ...restInnerProps } }) => (
    <Close
      ref={ref}
      {...restInnerProps}
      fontSize={"small"}
      style={{
        height: "1em",
        width: "1em",
        margin: "0 5px",
        fill: "rgba(0, 0, 0, 0.54)",
      }}
    />
  ),
  DropdownIndicator: ({ innerProps: { ref, ...restInnerProps } }) => (
    <ArrowDropDown
      ref={ref}
      {...restInnerProps}
      style={{
        fill: "rgba(0, 0, 0, 0.54)",
        margin: "2px 0",
      }}
    />
  ),
  IndicatorSeparator: null,
  Option: (props) => (
    <MenuItem
      {...props.innerProps}
      buttonRef={props.innerRef}
      selected={props.isFocused}
      component="div"
      style={{
        color: "rgba(0, 0, 0, 0.87)",
        paddingTop: 3,
        paddingBottom: 3,
        fontWeight: props.isSelected ? 500 : 400,
      }}
    >
      {props.children}
    </MenuItem>
  ),
  // Override single-value to easily allow style customization via CSS class names
  SingleValue: ({ children, ...props }) => (
    <components.SingleValue {...props} className="select--single-value">
      {children}
    </components.SingleValue>
  ),
};

const customStyles = {
  control: () => ({
    display: "flex",
    alignItems: "center",
    border: 0,
    height: "auto",
    background: "transparent",
    "&:hover": {
      boxShadow: "none",
    },
  }),
  valueContainer: (provided) => ({
    ...provided,
    padding: 0,
  }),
  container: (provided) => ({
    ...provided,
    boxSizing: "content-box",
    height: "auto",
  }),
  placeholder: (provided) => ({
    ...provided,
    color: "rgba(0, 0, 0, 0.35)",
  }),
  input: (provided) => ({
    ...provided,
    marginTop: 0,
    marginBottom: 0,
    paddingTop: 0,
    paddingBottom: 0,
    "& input": {
      font: "inherit",
    },
  }),
};

/**
 * A custom styled react-select AsyncCreatable component.
 * @param {Object} props Props for react-select's AsyncCreatable component.
 */
export function AsyncCreatableSelect(props) {
  return (
    <ReactSelectAsyncCreatable
      components={customComponents}
      styles={customStyles}
      {...props}
    />
  );
}

/**
 * A custom styled react-select Async component.
 * @param {Object} props Props for react-select's Async component.
 */
export function AsyncSelect(props) {
  return (
    <ReactSelectAsync
      components={customComponents}
      styles={customStyles}
      {...props}
    />
  );
}

const customStylesCreatable = {
  control: () => ({
    display: "flex",
    alignItems: "center",
    border: 0,
    height: "auto",
    background: "transparent",
    "&:hover": {
      boxShadow: "none",
    },
  }),
  valueContainer: (provided) => ({
    ...provided,
    padding: 0,
  }),
  placeholder: (provided) => ({
    ...provided,
    color: "rgba(0, 0, 0, 0.35)",
  }),
  input: (provided) => ({
    ...provided,
    minWidth: 250,
    marginTop: 0,
    marginBottom: 0,
    paddingTop: 0,
    paddingBottom: 0,
    "& input": {
      fontSize: 14,
    },
    "& input, & .select--single-value": {
      fontSize: 14,
    },
  }),
};
export function CreatableSelect(props) {
  return (
    <ReactSelectCreatable
      components={customComponents}
      styles={customStylesCreatable}
      {...props}
    />
  );
}



// WEBPACK FOOTER //
// ./src/components/Forms/Select.jsx